import { createSelector } from '@reduxjs/toolkit'
import { MedChronReference } from './schemas'
import { RootState } from '@/store/store'
import { MedChronReferencesRecord } from './slice'

/**
 * Select: Med Chron References by Job ID
 *
 * Returns the record of medical chronology references for the given job id, or null if it does not exist.
 */
export const selectMedChronReferencesByJobId = createSelector(
  [(state: RootState) => state.medChronReferencesState.references, (_: RootState, props: { medChronJobId: string | undefined | null }) => props.medChronJobId],
  (references, medChronJobId): MedChronReferencesRecord | null => {
    if (!medChronJobId) return null
    return references[medChronJobId] ?? null
  }
)

/**
 * Select: Med Chron Reference by ID
 *
 * Returns the medical chronology reference with the given id, or null if it does not exist.
 */
export const selectMedChronReferenceById = createSelector(
  [selectMedChronReferencesByJobId, (_: RootState, props: { medChronJobId: string | undefined | null; referenceId: string }) => props.referenceId],
  (references, referenceId): MedChronReference | null => {
    if (!references || !referenceId) return null
    return references[referenceId] ?? null
  }
)
